module.exports = __webpack_public_path__ + "static/media/banner_oquefalam_01-small.f30ccd44.png";